module.exports = __webpack_public_path__ + "static/img/empty_state.081a436f.png";